import { HTMLExtUtils } from '@ssml-editor/core';
import { SPEAK_HTML_NODE_NAME, SPEAK_TYPE } from './constant.js';

const speakElementToHtml = ({
  element,
  childrenHtml
}) => {
  const {
    mark,
    rate,
    pitch,
    volume,
    effect,
    effectValue,
    bgm,
    bgmName,
    bgmVolume
  } = element;
  return HTMLExtUtils.createElementAsString(
    SPEAK_HTML_NODE_NAME,
    SPEAK_TYPE,
    false,
    false,
    {
      mark,
      rate,
      pitch,
      volume,
      effect,
      "effect-value": effectValue,
      bgm,
      bgmName,
      "bgm-volume": bgmVolume
    },
    childrenHtml
  );
};

export { speakElementToHtml };
//# sourceMappingURL=element-to-html.js.map
